import React from 'react';
import PropTypes from 'prop-types';
import { withTranslations } from 'react-utilities';
import { translationConfig } from '../gameCarousel/translation.config';
import SearchResult from './containers/SearchResult';
import NewSearchResult from '../../../ts/react/gameSearch/GameSearch';
import { TGameEmphasisVariation } from '../../../ts/react/common/types/experimentTypes';
import { gameSearchPageContainerData } from '../../../ts/react/common/constants/browserConstants';

function App({ translate }) {
  const { gameEmphasisVariation = '' } = gameSearchPageContainerData() || {};
  if (gameEmphasisVariation === TGameEmphasisVariation.V2) {
    return <NewSearchResult translate={translate} />;
  }
  return <SearchResult translate={translate} />;
}

App.propTypes = {
  translate: PropTypes.func.isRequired
};
export default withTranslations(App, translationConfig);
